<div class="container-strategy">
  <div class="strategy-header" [ngStyle]="{'background-image': 'url(' + urlImage + ')'}">Stratégies</div>
</div>
